import { Input, Form, Typography } from "antd";
import "./Input.scss";

const { Text } = Typography;

const isEmailField = (type, name) => {
  if (type === "email") return true;
  const fieldName = String(name || "").toLowerCase();
  return (
    fieldName === "email" ||
    fieldName.endsWith("email") ||
    fieldName.includes("email")
  );
};

const sanitizeEmail = (value) =>
  typeof value === "string"
    ? value.toLowerCase().replace(/[^a-z0-9@.]/g, "")
    : value;

const CustomInput = ({
  label,
  type = "text",
  isRequired,
  isTextArea,
  isPassword,
  isUpperCase = false,
  removeHttps = false,
  allowComma = false,
  allowLettersOnly = false,
  allowNumbersOnly = false,
  className = "",
  dependencies,
  normalize,
  suffix,
  ...inputProps
}) => {
  const shouldLowercaseEmail = isEmailField(type, inputProps.name);

  const handleInput = (e) => {
    let value = e.target.value;

    // Email fields → lowercase, and only letters, numbers, @ and .
    if (shouldLowercaseEmail) {
      value = value.toLowerCase().replace(/[^a-z0-9@.]/g, "");
    }

    // Uppercase for PAN/GSTIN
    if (isUpperCase) {
      value = value.toUpperCase();
    }

    // Remove duplicate https://
    if (removeHttps) {
      value = value.replace(/^(https?:\/\/)+/gi, "");
    }

    // Comma formatting
    if (allowComma) {
      value = value.replace(/,/g, ""); // remove existing commas
      value = value.replace(/\D/g, ""); // only numbers
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if (allowLettersOnly) {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }

    if (allowNumbersOnly) {
      value = value.replace(/\D/g, "");
    }

    e.target.value = value;

    inputProps.onInput?.(e);
  };

  const handleWheel = (e) => {
    if (type === "number") {
      e.currentTarget.blur();
    }
    inputProps.onWheel?.(e);
  };
  return (
    <Form.Item
      label={label &&
        <Text>
          {label}
          {isRequired && <Text type="danger"> *</Text>}
        </Text>
      }
      name={inputProps.name}
      rules={inputProps.rules}
      dependencies={dependencies}
      normalize={normalize || (shouldLowercaseEmail ? sanitizeEmail : undefined)}
      className="custom-input-form-item"
    >
      {isTextArea ? (
        <Input.TextArea className={`custom-input ${className}`} {...inputProps} onInput={(e) => {
          if (isUpperCase) {
            e.target.value = e.target.value.toUpperCase();
          }
        }} />
      ) : isPassword ? (
        <Input.Password
          className="custom-input"
          {...inputProps}
        />
      ) : (
        <Input
          className={`custom-input ${className}`}
          {...inputProps}
          type={type}
          onInput={handleInput}
          onWheel={handleWheel}
          suffix={suffix}
        />
      )}
    </Form.Item>
  );
};

export default CustomInput;
